import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-gray-300 pt-16 pb-8 border-t border-gray-800" data-id="element-87">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12" data-id="element-89">
          {/* Brand Column */}
          <div className="lg:col-span-2" data-id="element-90">
            <a href="/" className="inline-block mb-6" data-id="element-91">
              <img src="https://cdn.magicpatterns.com/uploads/g1ZUhAWEqbLcGxsd7WaXTY/logo.png" alt="TKDScore.com Logo" className="h-12 w-auto" data-id="element-92" />
            </a>
            <p className="text-gray-400 mb-6 max-w-sm" data-id="element-93">
              The official distributor of Daedo electronic scoring equipment.
              Equipping elite athletes, schools, and tournaments with the best
              gear in Taekwondo.
            </p>
            <div className="flex space-x-4" data-id="element-94">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors" data-id="element-95">
                <FacebookIcon className="w-5 h-5" data-id="element-96" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-400 hover:text-white transition-colors" data-id="element-97">
                <TwitterIcon className="w-5 h-5" data-id="element-98" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-pink-600 hover:text-white transition-colors" data-id="element-99">
                <InstagramIcon className="w-5 h-5" data-id="element-100" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-red-600 hover:text-white transition-colors" data-id="element-101">
                <YoutubeIcon className="w-5 h-5" data-id="element-102" />
              </a>
            </div>
          </div>

          {/* Shop Column */}
          <div data-id="element-103">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-104">
              Shop
            </h4>
            <ul className="space-y-3" data-id="element-105">
              <li data-id="element-106">
                <a href="#daedo-pss-systems" className="hover:text-blue-400 transition-colors" data-id="element-107">
                  Daedo PSS Systems
                </a>
              </li>
              <li data-id="element-108">
                <a href="#daedo-products" className="hover:text-blue-400 transition-colors" data-id="element-109">
                  Daedo Products
                </a>
              </li>
              <li data-id="element-110">
                <a href="#wacoku-products" className="hover:text-blue-400 transition-colors" data-id="element-111">
                  Wacoku Products
                </a>
              </li>
            </ul>
          </div>

          {/* Support Column */}
          <div data-id="element-112">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-113">
              Support
            </h4>
            <ul className="space-y-3" data-id="element-114">
              <li data-id="element-115">
                <a href="https://www.daedosupport.com/portal/en/kb/tkd-score" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors" data-id="element-116">
                  Contact Us
                </a>
              </li>
              <li data-id="element-117">
                <a href="https://www.daedosupport.com/portal/en/kb/tkd-score" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors" data-id="element-118">
                  Create Ticket
                </a>
              </li>
              <li data-id="element-119">
                <a href="#support-software" className="hover:text-blue-400 transition-colors" data-id="element-120">
                  Software Downloads
                </a>
              </li>
              <li data-id="element-121">
                <a href="#support-thresholds" className="hover:text-blue-400 transition-colors" data-id="element-122">
                  Hit Thresholds
                </a>
              </li>
              <li data-id="element-123">
                <a href="#returns" className="hover:text-blue-400 transition-colors" data-id="element-124">
                  Returns & Exchanges
                </a>
              </li>
              <li data-id="element-125">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-126">
                  Shipping Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Account Column */}
          <div data-id="element-127">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-128">
              Account
            </h4>
            <ul className="space-y-3" data-id="element-129">
              <li data-id="element-130">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-131">
                  My Account
                </a>
              </li>
              <li data-id="element-132">
                <a href="#" className="hover:text-blue-400 transition-colors" data-id="element-133">
                  Order History
                </a>
              </li>
              <li data-id="element-134">
                <a href="#financing" className="hover:text-blue-400 transition-colors" data-id="element-135">
                  Financing
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-136">
          <p className="text-sm text-gray-500 mb-4 md:mb-0" data-id="element-137">
            &copy; {new Date().getFullYear()} TKDScore.com. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-500" data-id="element-138">
            <a href="#" className="hover:text-white transition-colors" data-id="element-139">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-140">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}